module.exports = __webpack_public_path__ + "img/DP358.d4688b90.jpg";